export const Version = "1.0.23";

export const keyUI = "yaXf4qGwJr";

// export const keyUserCompany = "kvPPAlqQH7"; chave anterior
export const keyUserCompany = "Q9QEDM";

//secrets do sistema
export const secret = {
  tsDebtor: `${keyUI}_u+dVpxQDsIe9rfFD`,
  userData: `${keyUI}_mDqVybliPA/QCTw`,
  contracts: `${keyUI}_N7nAGLV51uMv49HR`,
  chat: `${keyUI}_N7nAGLV51uMv49H`,
  parameters: `${keyUI}_6Lc9eV0UAAAAAP6`,
};

//recaptcha google Site key.
export const siteKey = "6Lc9eV0UAAAAAP6eVDrfTzruvpCIo7YghK7iugel";

export const dadosModulo = {
  ipUI: "",
  moduleUI: "app-debtor",
  versionUI: Version,
  keyUI: keyUI,
};
